import { render, staticRenderFns } from "./AddTaskList.vue?vue&type=template&id=e1f8bd1c"
import script from "./AddTaskList.vue?vue&type=script&lang=js"
export * from "./AddTaskList.vue?vue&type=script&lang=js"
import style0 from "./AddTaskList.vue?vue&type=style&index=0&id=e1f8bd1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports